import React from "react";
import Button from "../ui/Button";
import EditText from "../ui/EditText";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-auto bg-[#1c233a]  ">
      <div className=" max-w-[1700px] mx-auto">
        <div className="relative w-auto h-auto">
          {/* Main content */}
          <div className="relative z-10 p-[20px] sm:p-[30px] 2xl:py-[40px]">
            <div className="ml-[0px] sm:ml-[40px] 2xl:ml-[54px]">
              <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-[84px]  w-auto">
                {/* Left Section - Company Info & Social */}
                <div className="flex flex-col gap-[12px] sm:gap-[18px] 2xl:gap-[24px] justify-start items-start w-auto lg:w-[30%]">
                  {/* Logo Section */}
                  <Link to="/" className="relative block">
                    <div className="flex 2xl:justify-start 2xl:items-center gap-[10px] w-full ">
                      <div className="relative">
                        <img
                          src="/images/BottomLogo.webp"
                          alt="Company LogoCircle"
                          className=" w-[50px] h-[50px] 2xl:w-auto 2xl:h-auto animate-spin-slow" // <<<--- **HERE IS THE CHANGE**
                        />
                        <div className="absolute top-0">
                          <img
                            src="/images/TopLogo.webp"
                            alt="Company LogoCircle"
                            className=" w-[50px] h-[50px] 2xl:w-auto 2xl:h-auto " // <<<--- **HERE IS THE CHANGE**
                          />
                        </div>
                      </div>
                      <div className="flex justify-center items-center ">
                        <img
                          src="/images/logoText.png"
                          alt="Company Logo"
                          className="hidden md:block 2xl:w-auto 2xl:h-auto"
                        />
                      </div>
                    </div>
                  </Link>
                  {/* Description */}
                  <p className="text-[16px] mb-[20px] md:mb-[50px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] 2xl:leading-[38px] text-left text-white font-[Sora] w-full">
                    Sustaining Life, Energising Future
                  </p>

                  {/* Social Media Icons */}
                  <div className="flex gap-[10px] sm:gap-[15px] 2xl:gap-[20px] justify-start items-center w-auto">
                    <Link
                      to="https://www.youtube.com/channel/UC0I2wlFUc9IkXHKtxIg71gA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Facebook"
                      >
                        <img
                          src="/images/youtube.svg"
                          alt="youtube"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://www.instagram.com/utpann_organic_fertilizer/#"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Facebook"
                      >
                        <img
                          src="/images/insta.svg"
                          alt="Facebook"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://www.facebook.com/utpannorganicfertilizer/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Twitter"
                      >
                        <img
                          src="/images/faceBook.svg"
                          alt="Twitter"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://www.linkedin.com/company/govardhannathji-energies-llp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="LinkedIn"
                      >
                        <img
                          src="/images/in.svg"
                          alt="LinkedIn"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[30px] 2xl:h-[30px]"
                        />
                      </button>
                    </Link>
                    <Link
                      to="https://x.com/utpann_in"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] 2xl:w-[60px] 2xl:h-[60px] bg-white rounded-[5px] sm:rounded-[7px] 2xl:rounded-[10px] flex items-center justify-center hover:opacity-80 transition-opacity"
                        aria-label="Instagram"
                      >
                        <img
                          src="/images/x.svg"
                          alt="Instagram"
                          className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] 2xl:w-[32px] 2xl:h-[32px]"
                        />
                      </button>
                    </Link>
                  </div>
                </div>

                {/* Right Section - Contact Details & Newsletter */}
                <div className="flex flex-wrap  justify-between lg:flex-nowrap gap-8 lg:gap-[50px] w-auto lg:w-auto">
                  {/* Contact Details */}

                  {/* Center Section - Quick Links */}
                  <div className="flex flex-col justify-start items-start w-auto lg:w-[40%]">
                    <h3 className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                      Quick Links
                    </h3>
                    <a
                      href="/about"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[12px] sm:mt-[18px] 2xl:mt-[24px] hover:opacity-75 transition-opacity"
                    >
                      About Us
                    </a>
                    <a
                      href="/products"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[8px] sm:mt-[12px] 2xl:mt-[16px] hover:opacity-75 transition-opacity"
                    >
                      Products
                    </a>
                    <a
                      href="/biogas-plant"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[8px] sm:mt-[12px] 2xl:mt-[16px] hover:opacity-75 transition-opacity"
                    >
                      Biogas Plant
                    </a>
                    <a
                      href="/"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[10px] sm:mt-[15px] 2xl:mt-[20px] hover:opacity-75 transition-opacity"
                    >
                      Blog
                    </a>
                    <a
                      href="/contact"
                      className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora] mt-[7px] sm:mt-[10px] 2xl:mt-[14px] hover:opacity-75 transition-opacity"
                    >
                      Contact
                    </a>
                  </div>
                  <div className="flex flex-col gap-[11px] sm:gap-[16px] 2xl:gap-[22px] justify-start items-start w-auto lg:w-[60%]">
                    <h3 className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                      Contact Details
                    </h3>

                    <ul className="flex flex-col justify-start items-start w-auto space-y-4">
                      <li>
                        <a
                          href="tel:+918645888881"
                          className="flex gap-[9px] sm:gap-[14px] 2xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity"
                        >
                          <img
                            src="/images/callIcon.svg"
                            alt="Phone"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] 2xl:w-[30px] 2xl:h-[30px]"
                          />
                          <span className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                            +91 86 45 88 88 81
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="mailto:info@utpann.in"
                          className="flex gap-[9px] sm:gap-[14px] 2xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity mt-[12px] sm:mt-[18px] 2xl:mt-[24px]"
                        >
                          <img
                            src="/images/EmailIcon.svg"
                            alt="Email"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] 2xl:w-[30px] 2xl:h-[30px] self-start"
                          />
                          <span className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                            info@utpann.in
                          </span>
                        </a>
                      </li>
                      <li>
                        <div className="flex gap-[9px] sm:gap-[14px] 2xl:gap-[18px] justify-start items-start w-auto mt-[7px] sm:mt-[10px] 2xl:mt-[14px]">
                          <img
                            src="/images/locationIcon.svg"
                            alt="Address"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] 2xl:w-[30px] 2xl:h-[30px]"
                          />
                          <p className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] 2xl:leading-[38px] text-left text-white font-[Sora] self-center w-[90%]">
                            Sr. No. 2373, Sim Vistar, At & Po-Pij, Ta-Vaso,
                            <br />
                            Dist-Nadiad, Gujarat 387230
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* Newsletter Subscription */}
                  <div className="hidden flex-col gap-[10px] sm:gap-[15px] 2xl:gap-[20px] justify-start items-start w-auto lg:w-[34%]">
                    <h3 className="text-[16px] sm:text-[20px] 2xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] 2xl:leading-[31px] text-left text-white font-[Sora]">
                      Subscribe to Our Newsletter
                    </h3>

                    <EditText
                      placeholder="Enter your mail"
                      text_font_size="14"
                      text_font_family="Sora"
                      text_font_weight="400"
                      text_line_height="18px"
                      text_text_align="start"
                      text_color="#ffffff7f"
                      border_border="1px solid #ffffff"
                      border_border_radius="30px"
                      padding="7px 15px"
                      className="w-full text-[14px] sm:text-[17px] 2xl:text-[20px] leading-[18px] sm:leading-[22px] 2xl:leading-[26px] py-[7px] px-[15px] sm:py-[10px] sm:px-[22px] 2xl:py-[14px] 2xl:px-[30px]"
                    />

                    <Button
                      text="Submit"
                      text_font_size="16"
                      text_font_family="Sora"
                      text_font_weight="700"
                      text_line_height="20px"
                      text_text_align="center"
                      text_color="#1c233a"
                      fill_background_color="#7abf6b"
                      border_border_radius="30px"
                      border_border="none"
                      padding="6px 17px"
                      className="w-auto text-[16px] sm:text-[20px] 2xl:text-[24px] leading-[20px] sm:leading-[25px] 2xl:leading-[31px] py-[6px] px-[17px] sm:py-[9px] sm:px-[25px] 2xl:py-[12px] 2xl:px-[34px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Background watermark text */}
          <div className="  flex items-end justify-center z-0">
            <img
              src="/images/contactFooter.webp"
              alt="Watermark Text"
              className="w-auto"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
